const Validate = function(model, fields) {
    let results= {};
    let state = true;

    Object.keys(fields).forEach(key=> {
        try {
            let error = Validate.validator(fields[key], eval(`model.${key}`));

            results[key] = error
            state = state && (error ? false : true)
        }
        catch(err) {
            throw err;
        }
    })
    return { state, results };
};

Validate.validator = function(rules, value) {
    let message = '';
    
    function catchError(err) {
        message = err ? err.message : ''
    }

    if(Array.isArray(rules)) {
        let result = '';

        rules.forEach(rule=> {
            result = Validate.validator(rule, value)
        })
        return result;
    }
    else {
        let keys = Object.keys(rules).filter(v=> typeof RULES[v] === 'function');
        let keyLen = keys.length;

        while(keyLen--) {
            let key = keys[keyLen];

            try {
                RULES[key](rules, value, catchError);
            }
            catch(err) {
                console.error(err)
                throw err;
            }
        }

        return message;
    }// end if
}

const RULES = {
    required: function(rules, value, callback) {
        if(!!rules.required && (value === '' || value == null)) {
            callback(new Error(rules.message))
        }
        else {
            callback()
        }
    },

    type: function(rules, value, callback) {
        const reg = {
            'email': /^[a-z\d]+(\.[a-z\d]+)*@([\da-z](-[\da-z])?)+(\.{1,2}[a-z]+)+$/,
            'phone': /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$/,
            'url': /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
            'number': /^-?([1-9]\d*\.\d*|0\.\d*[1-9]\d*)|0|0.\d+$/,
        };

        if(!reg[rules.type]) {
            throw new Error(`unexcepted type: ${rules.type}.`);
        }
        
        return reg[rules.type].test(value.trim())
            ? callback()
            : callback(new Error(rules.message));
    },

    minlength: function(rules, value, callback) {
        return value.length >= rules.minlength
            ? callback()
            : callback(new Error(rules.message));
    },

    maxlength: function(rules, value, callback) {
        return value.length <= rules.maxlength
            ? callback()
            : callback(new Error(rules.message));
    },

    min: function(rules, value, callback) {
        value = Number(value)

        return isNaN(value) ? false : value >= Number(rules.min)
            ? callback()
            : callback(new Error(rules.message));
    },

    max: function(rules, value, callback) {
        value = Number(value)

        return isNaN(value) ? false : value <= Number(rules.max)
            ? callback()
            : callback(new Error(rules.message));
    },

    validator: function(rules, value, callback) {
        rules.validator(rules, value, callback)
    },
};

export default Validate;